import { action, observable } from 'mobx';

import { GET_AVAILABLE_START_YEAR } from '../constants/apiUrls/apiUrls';
import forResponse from '../utils/forResponse';
import http from '../services/http/index';

const DEFAULT_YEAR_ARCHIVE_CONTENT_STARTS = 2011;
const CURRENT_DATE = new Date();

class ArchiveDateStore {
  @observable startYear = null;
  @observable yearsList = [];
  @observable isLoaded = false;
  @observable months = [
    { name: 'January', number: '01' },
    { name: 'February', number: '02' },
    { name: 'March', number: '03' },
    { name: 'April', number: '04' },
    { name: 'May', number: '05' },
    { name: 'June', number: '06' },
    { name: 'July', number: '07' },
    { name: 'August', number: '08' },
    { name: 'September', number: '09' },
    { name: 'October', number: '10' },
    { name: 'November', number: '11' },
    { name: 'December', number: '12' },
  ];

  @observable selectedYear = null;
  @observable selectedMonth = null;

  @action
  setStartYear = async () => {
    if (this.startYear) {
      return null;
    }
    const { data, error } = await this.fetchStartYear();
    if (!error) {
      this.startYear = data?.data?.startYear;
    } else {
      this.startYear = DEFAULT_YEAR_ARCHIVE_CONTENT_STARTS;
    }

    if (!this.selectedYear) {
      this.selectedYear = CURRENT_DATE.getFullYear();
    }
    if (!this.selectedMonth) {
      const currentMonth = CURRENT_DATE.getMonth() + 1;
      this.selectedMonth = currentMonth.toString().padStart(2, '0');

    }
    this.generateYears();
  };

  fetchStartYear = () => forResponse(http.get(GET_AVAILABLE_START_YEAR));

  generateYears = () => {
    const currentYear = new Date().getFullYear();
    this.yearsList = [];
    for (let i = this.startYear; i <= currentYear; i++) {
      this.yearsList.push(i);
    }
  };

  get years() {
    return this.yearsList;
  }

  get yearsFromLatest() {
    return this.yearsList.slice().reverse();
  }

  get monthsFromLatest() {
    return this.months.slice().reverse();
  }

  get monthsInCurrentYearFromLatest() {
    return this.months.slice(0, this.getCurrentMonthIndex() + 1).reverse();
  }

  getCurrentMonthIndex() {
    return new Date().getMonth();
  }

  getSelectedMonth = (currentYear) =>
    currentYear === this.yearsFromLatest[0]
      ? this.monthsInCurrentYearFromLatest[0].number
      : this.months[0].number;

  @action setSelectedMonth = (value) => {
    this.selectedMonth = value;
  };

  @action setSelectedYear = (value) => {
    this.selectedYear = value;
  };

  @action
  resetState = () => {
    this.startYear = 2011;
    this.yearsList = [];
    this.isLoaded = false;
    this.selectedMonth = null;
    this.selectedYear = null;
  };
}

export default new ArchiveDateStore();
